import { StandardEvents } from '@shopify/events';

class JlCartCount extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate, { signal });
    window.addEventListener('pageshow', this.refresh, { signal });
    document.addEventListener('visibilitychange', this.onVisibilityChange, { signal });
    this.refresh();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.request?.abort();
  }

  onVisibilityChange = () => {
    if (document.visibilityState === 'visible') this.refresh();
  };

  onCartUpdate = (event) => {
    // A change event starts before the mutation completes. Read only after success.
    if (!event.promise) return;
    event.promise.then(() => {
      if (this.isConnected) this.refresh();
    }).catch(() => {});
  };

  refresh = async () => {
    this.request?.abort();
    const request = new AbortController();
    this.request = request;
    try {
      const response = await fetch(this.dataset.cartUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: request.signal,
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (request.signal.aborted || this.request !== request || !this.isConnected) return;
      const count = cart.item_count;
      if (!Number.isInteger(count) || count < 0) return;
      const badge = this.querySelector('[data-cart-count]');
      const link = this.querySelector('.pw-cart-link');
      if (!badge || !link) return;
      const label = this.dataset.cartLabel + ', ' + count;
      const changed = badge.textContent.trim() !== String(count);
      badge.textContent = String(count);
      link.setAttribute('aria-label', label);
      const status = this.querySelector('[data-cart-count-status]');
      if (changed && status) status.textContent = label;
    } catch {
      // Keep the last confirmed count when offline or a newer refresh cancels this one.
    }
  };
}

if (!customElements.get('jl-cart-count')) {
  customElements.define('jl-cart-count', JlCartCount);
}
